import siteConfig from "site-config";
import { fetchJSON } from "lib/fetch";
import { useInfiniteQuery, InfiniteQueryConfig, QueryKey } from "react-query";
import lodashIsEmpty from "lodash/isEmpty";
import { stringify } from "query-string";

export const CATALOGS = "catalogs";

export interface ICatalog {
    active: boolean;
    id: string;
    title: string;
    sort: number;
}

export interface IListCatalogsRequest {
    __limit?: number;
    __last_id?: string;
    __last_value?: number;
    type?: string;
    active?: boolean;
}

export interface IFetchCatalogsMoreOpts {
    lastId?: string;
    lastValue?: number;
}

function buildCacheKeys(filter?: Partial<IListCatalogsRequest>): QueryKey {
    const compositeIds = { filter: undefined };

    if (filter && Object.keys(filter).length) {
        compositeIds.filter = filter;
    }

    return [CATALOGS, compositeIds];
}

export const useInfiniteFetchCatalogs = (
    query: IListCatalogsRequest,
    options?: Partial<InfiniteQueryConfig<ICatalog[], string>>,
) => {
    return useInfiniteQuery<ICatalog[], QueryKey>(
        buildCacheKeys(query),
        (_catalogsKey, _filterKey, last: IFetchCatalogsMoreOpts) => {
            const mutatedQuery = { ...query };
            mutatedQuery.__last_id = last?.lastId;
            mutatedQuery.__last_value = last?.lastValue;
            return fetchJSON<ICatalog[]>(
                `${siteConfig.api}/api/v3.1/catalogs${
                    !lodashIsEmpty(mutatedQuery) ? `?${stringify(mutatedQuery)}` : ""
                }`,
                {
                    method: "GET",
                    noDomain: true,
                },
            );
        },
        {
            ...options,
            getFetchMore: (lastpage) => {
                const lastId = lastpage[lastpage.length - 1]?.id;
                const lastValue = lastpage[lastpage.length - 1]?.sort;
                return lastpage.length === query?.__limit ? { lastId, lastValue } : undefined;
            },
        },
    );
};
